import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { useDeleteSearchFilterMutation } from "../../../App/Queries/FilterQueries";
import { useNotification } from "../../../App/State/Hooks/notificationHooks";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import Modal from "../../../App/Components/Modal/Modal";
import { Dispatch, SetStateAction } from "react";
import { Rule } from "../../../App/Typings/DynamicGroupRules";
import { ISavedSearch } from "../../../App/Typings/SearchFilters";

export function CandidatesCapturedSavedFilters({
  handleSetRules,
  setCurrentFilter,
  dialogOpen,
  handleDialogClose,
  savedSearchFilters,
}: {
  handleSetRules: (rules: Rule[]) => void;
  setCurrentFilter: Dispatch<SetStateAction<ISavedSearch | null>>;
  dialogOpen: boolean;
  handleDialogClose: () => void;
  savedSearchFilters: ISavedSearch[];
}) {
  const deleteSearchFilterMutation = useDeleteSearchFilterMutation();
  const { displayError, displaySuccess } = useNotification();
  const sortedSavedSearchFilters = savedSearchFilters.sort((a, b) => (a.name > b.name ? 1 : -1));

  const handleItemClick = (savedFilter: ISavedSearch) => {
    handleSetRules(JSON.parse(savedFilter.searchString) as Rule[]);
    setCurrentFilter(savedFilter);
    displaySuccess(`Filter applied: ${savedFilter.name}`);
  };

  const handleDeleteFilter = async (savedFilter: ISavedSearch) => {
    deleteSearchFilterMutation.mutate(savedFilter.id, {
      onError: () => {
        displayError("Error deleting filter");
      },
      onSuccess: () => {
        displaySuccess("Filter deleted");
      },
    });
  };

  return (
    <Modal
      isOpen={dialogOpen}
      handleCloseModal={handleDialogClose}
      title="Load Saved Filters"
      dataTestId="load-saved-filters-modal"
      content={
        <>
          {sortedSavedSearchFilters && savedSearchFilters.length > 0 ? (
            <List sx={{ minWidth: 400 }}>
              {sortedSavedSearchFilters.map((filter: ISavedSearch) => (
                <ListItem
                  key={filter.id}
                  sx={{ borderBottom: "1px #ccc solid" }}
                  secondaryAction={
                    <IconButton
                      title="Delete filter"
                      color="error"
                      edge="end"
                      aria-label="delete"
                      onClick={() => handleDeleteFilter(filter)}
                      data-test={"savedfilter-delete-" + filter.id}
                    >
                      <DeleteIcon />
                    </IconButton>
                  }
                >
                  <ListItemButton
                    onClick={() => {
                      handleItemClick(filter);
                      handleDialogClose();
                    }}
                    title="Load filter"
                    data-test={"savedfilter-select-" + filter.id}
                  >
                    <ListItemIcon>
                      <FilterListIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography>
                          <span style={{ fontWeight: "bold" }}>{filter.name}</span>
                          {filter.isPersonalFilter ? " (Private)" : null}
                        </Typography>
                      }
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          ) : (
            <Box sx={{ minWidth: 400 }}>
              <Typography>No saved filters to display.</Typography>
            </Box>
          )}
        </>
      }
      footerContent={<></>}
    />
  );
}
